<template>
  <div class="flex flex-row">
    <h2 class="flex-1 text-left text-xl text-dark-gray">Invitations</h2>
    <button-main
      class="flex flex-1 cursor-pointer flex-row items-center justify-end text-1md text-yellow-500"
      variant="link"
      @click="openInvitationModal"
    >
      Invite New User
      <img
        class="ml-1"
        src="@/assets/plus-yellow-icon.svg"
        alt="close icon"
      />
    </button-main>
  </div>
  <div v-if="userInvitations.length">
    <div class="w-full">
      <table class="w-full">
        <thead>
          <tr>
            <th>Invite Email</th>
            <th>Sent By</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody class="rounded-md border-2">
          <tr
            v-for="(invitation, rowIndex) in userInvitations"
            :key="rowIndex"
            :class="[rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50', 'py-2']"
          >
            <td>
              <span>{{ invitation.email }}</span>
            </td>
            <td>
              <span>
                {{ invitation.creator.name }}
                {{ displayDate(invitation.created_at) }}</span
              >
            </td>
            <td>
              <span>
                <status-button
                  size="xs"
                  :value="invitation.status"
              /></span>
            </td>

            <td>
              <div class="flex flex-row items-center">
                <div class="h-8 w-8">
                  <popper
                    placement="top"
                    :hover="invitation.status === 'claimed' ? false : true"
                    :disabled="invitation.status === 'claimed'"
                  >
                    <button
                      :disabled="invitation.status === 'claimed'"
                      class="rounded hover:bg-light-gray"
                      :class="
                        invitation.status === 'claimed'
                          ? 'btn-disabled cursor-default opacity-50'
                          : ''
                      "
                      @click="deleteInviation(invitation.id)"
                    >
                      <img
                        class="relative inline h-8 w-8 cursor-pointer"
                        src="@/assets/trash-icon-big.svg"
                        alt=" delete"
                      />
                    </button>
                    <template #content>
                      <div
                        class="w-auto rounded-md bg-dark-gray px-2 py-1 text-left text-2xs text-light-gray"
                      >
                        Delete invitation
                      </div>
                    </template>
                  </popper>
                </div>
                <div>
                  <popper
                    placement="top"
                    :hover="invitation.status === 'claimed' ? false : true"
                    :disabled="invitation.status === 'claimed'"
                  >
                    <button
                      :disabled="invitation.status === 'claimed'"
                      :class="
                        invitation.status === 'claimed'
                          ? 'btn-disabled cursor-default opacity-50'
                          : ''
                      "
                      class="rounded hover:bg-light-gray"
                      @click="resendInvitation(invitation.id)"
                    >
                      <img
                        class="relative ml-3 inline h-6 w-6 cursor-pointer"
                        src="@/assets/refresh-icon.svg"
                        alt=" delete"
                      />
                    </button>
                    <template #content>
                      <div
                        class="w-auto rounded-md bg-dark-gray px-2 py-1 text-left text-2xs text-light-gray"
                      >
                        Resend Invitation
                      </div>
                    </template>
                  </popper>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    v-else
    class="empty-state-container mt-4 flex justify-center rounded-lg bg-off-white"
  >
    <span class="text-center text-base text-gray-over-dark">
      You currently do not have any pending invitations for users to join this
      account.
    </span>
  </div>
  <invite-user-modal
    v-if="showCreateInvitation"
    :visible="showCreateInvitation"
    @invitation-sent="invitationSent"
    @close="closeInvitationModal"
  />
</template>
<script>
import moment from 'moment';
import Popper from 'vue3-popper';
import StatusButton from '@/components/StatusButton.vue';
import UserInvite from '@/mixins/userInvite';
import WordTools from '@/mixins/wordTools';
import { toastResponse } from '@/common/handleServerResponse';

export default {
  name: 'InvitationsTable',
  components: {
    Popper,
    StatusButton,
  },
  mixins: [UserInvite, WordTools],
  data() {},
  computed: {
    userInvitations() {
      return this.$store.state.userInvitations.collection || [];
    },
  },
  async created() {
    await this.$store.dispatch('userInvitations/getUserInvitations');
  },
  methods: {
    closeInvitationModal() {
      this.showCreateInvitation = false;
    },
    displayDate(date) {
      if (date) {
        return moment(date, 'YYYY-MM-DD').format('M/D/YY');
      }
    },
    async deleteInviation(invitationId) {
      let res = await this.$store.dispatch(
        'userInvitations/destroyUserInvitation',
        invitationId
      );
      toastResponse(this, res, 'Invitation deleted');
    },
    async resendInvitation(invitationId) {
      let res = await this.$store.dispatch(
        'userInvitations/resendUserInvitation',
        invitationId
      );
      toastResponse(this, res, 'The invitation has been resent');
    },
  },
};
</script>
<style scoped>
.tabs-item {
  @apply block w-full text-xs font-medium uppercase leading-tight;
  @apply my-2 px-6 py-3;
  @apply hover:bg-gray-100;
}

.btn-disabled {
  @apply hover:bg-white !important;
}

.notice-text {
  @apply text-center text-gray-over-dark;
  font-size: 14px;
}

.empty-state-container {
  padding: 50px 16px !important;
}

table {
  border-collapse: separate;
  border-spacing: 0;
  background: white;
  border-radius: 10px;
  font-size: 12px;
  /* border: 1px solid rgb(237, 237, 240); */
}
table tr td {
  color: #6d7181;
  padding: 15px;
}
thead {
  background: white;
  padding: 10px 10px 10px 0;
  height: 40px;
  margin-top: 10px;
}
tbody {
  box-shadow: 0 0 0 1px rgb(237, 237, 240);
  border-radius: 10px;
  z-index: 4;
}

th {
  padding: 10px 10px 0 15px;
}
table tr:first-child td:first-child {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
table tr:first-child td:last-child {
  border-top-right-radius: 15px;
}
table tr:last-child td:first-child {
  border-bottom-left-radius: 15px;
}
table tr:last-child td:last-child {
  border-bottom-right-radius: 15px;
}
</style>
